import ListView from 'components/widgets/ProjectInsights/SearchResultsViews/ListView';
import MapView from 'components/widgets/ProjectInsights/SearchResultsViews/MapView';

const SearchResultsViews = ({ viewType }: { viewType: 'list' | 'map' }) => {
  if (viewType === 'list') {
    return <ListView />;
  }

  return <MapView />;
};

export default SearchResultsViews;
